import { useEffect, useState } from 'react';
import { FieldValues, useForm } from 'react-hook-form';
import { AppModal } from '../../../../global/Modal';

import Chip from '@mui/material/Chip';
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';
import { IAppModalProps } from '../../../../global/Modal/AppModal';
import { useSettingAccessUserGroupPageContext } from '../../../../../pages/Setting/Access/UserGroup';
import { DUserFormValues, IUserFormValues } from '../../../../../pages/Setting/Access/User';
import AutoCompleteInput from '../../../../global/Input/AutoCompleteInput';
import { ISelectOptions } from '../../../../global/Input/SelectInput';
import { useGetAllUsers } from '../../../../../hook/query/userCRUD';

export interface IAddMemberModalProps extends IAppModalProps {
    currentMember: any,
}

export type IUserForAddMember = {
    username: string,
    id: any
}

export interface IUserMembersSelectOptions extends ISelectOptions {
    username: string,
}

export default function AddMemberModal({ onConfirm, currentMember, ...other }: IAddMemberModalProps) {

    const { uuid, } = useSettingAccessUserGroupPageContext()

    const { data: usersData, isLoading: usersLoading } = useGetAllUsers()

    const { control, getValues, setValue, reset } = useForm<{ users: IUserFormValues[] | [] }>({
        defaultValues: {
            users: currentMember.filter(item => item.is_remove === 0)
        }
    })

    const [memberOption, setMemberOption] = useState<IUserMembersSelectOptions[]>([])

    const handleConfirm = (e: Event) => {
        let values = getValues();
        onConfirm?.(e, values.users)
    }

    useEffect(() => {
        if (usersData) {
            let sortMember = usersData.map(user => ({ id:user.id, avatar: user.avatar, user_uuid:user.uuid, uuid: user.uuid, firstname: user.firstname, lastname: user.lastname, value: user.uuid, option: user?.firstname + ' ' + user?.lastname }))
            setMemberOption(sortMember)
        }
    }, [usersData])

    const handleOnClose = () => {
        reset({ users: currentMember.filter(item => item.is_remove === 0)})
        other?.onClose?.()
    }

    useEffect(()=>{
        reset({
            users: currentMember.filter(item => item.is_remove === 0)
        })
    },[currentMember])

    const isReadyToAction = !usersLoading

    return (
        <AppModal {...other} onConfirm={handleConfirm} onClose={handleOnClose}>
            <div>
                <AutoCompleteInput disabled={!isReadyToAction} label="รายชื่อสมาชิก" placeholder="สมาชิก" multiple id="users" name="users" options={memberOption} control={control} />
            </div>
        </AppModal>
    );
}
